import { Entity, Field } from "typegraph";

@Entity({one: "tag", many: "tags"})
export default class Tag {

	@Field()
	public id: number;

	@Field()
	public name: string;

}



// WEBPACK FOOTER //
// ./src/panels/subscriptions/entities/Tag.ts